import { NotificationHelper } from 'src/core/models/notification/types/notification.helper';

export function NotificationType(type: string, cmp: any) {
  const actualDecorator = (target: any): void => {
    NotificationHelper.notificationList.set(type, cmp);
  };

  return actualDecorator;
}
